"use client"

import { lazy, Suspense } from "react"

const Globe = lazy(() =>
  import("@/components/globe").then((mod) => ({ default: mod.Globe })),
)

export function HeroGlobe() {
  return (
    <div className="relative mx-auto w-full max-w-lg">
      <div className="absolute inset-0 rounded-full bg-primary/10 blur-3xl" />
      <Suspense
        fallback={
          <div className="aspect-square w-full max-w-md animate-pulse rounded-full bg-white/5" />
        }
      >
        <Globe />
      </Suspense>
    </div>
  )
}
